function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCakeBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.172,
    height: 15.171,
    viewBox: "0 0 15.172 15.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.54 13.909h-.632V8.851a3.165 3.165 0 0 0-3.161-3.161H8.218V3.818a1.58 1.58 0 0 0 .948-1.447A4.611 4.611 0 0 0 8.053.207a.632.632 0 0 0-.933 0 4.611 4.611 0 0 0-1.114 2.164 1.58 1.58 0 0 0 .948 1.447V5.69H4.425a3.165 3.165 0 0 0-3.161 3.161v5.057H.632a.632.632 0 1 0 0 1.264H14.54a.632.632 0 0 0 0-1.264zM4.425 6.955h6.322a1.9 1.9 0 0 1 1.9 1.9V10.1c-.592-.063-.948-.443-.948-.62a.632.632 0 0 0-1.264 0c0 .217-.431.632-1.106.632s-1.106-.439-1.106-.632a.632.632 0 0 0-1.264 0c0 .217-.431.632-1.106.632s-1.106-.439-1.106-.632a.632.632 0 0 0-1.264 0c0 .2-.366.561-.948.62V8.851a1.9 1.9 0 0 1 1.9-1.9zm-1.9 4.412a2.627 2.627 0 0 0 1.58-.619 2.724 2.724 0 0 0 3.477.009 2.724 2.724 0 0 0 3.477-.009 2.627 2.627 0 0 0 1.58.618v2.543H2.529z",
    transform: "translate(0 -.002)",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakeBirthday);
export default __webpack_public_path__ + "static/media/cake-birthday.836205aa456257c101aafbfcc1b835a7.svg";
export { ForwardRef as ReactComponent };